/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Services */

/**
 * Renders Shambhavi Quote Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data of the section from api
 * @returns {ReactElement} Shambhavi Quote component
 */
const ShambhaviQuote = ({ sectionContent }) => {
  const fullQuote = sectionContent?.quote || '';
  const quoteParts = fullQuote.split('–');
  const quote = quoteParts[0];
  const author = quoteParts.length > 1 ? `–${quoteParts[1]}` : null;
  return (
    <Box
      maxW={{ sm: '600px', md: '712px' }}
      fontFamily="FedraSansStd-book"
      fontStyle={'italic'}
      fontWeight="400"
      color="#3C0000"
      fontSize={'18px'}
      lineHeight={'130%'}
      textAlign={{ base: 'center', md: 'left' }}
      mb={{ base: 2, lg: 3 }}
    >
      {quote}
      {author && (
        <Text
          mt={{ base: 0.5, md: 0.2 }}
          as="span"
          display="block"
          textAlign={{ base: 'center', md: 'left' }}
        >
          {author}
        </Text>
      )}
    </Box>
  );
};

export default ShambhaviQuote;
